import { isFocusable } from "./isFocusable";

export const isFocusableDeepWithin = (element: HTMLElement): boolean => {
  return (
    element instanceof HTMLSlotElement
      ? element.assignedElements()
      : Array.from((element.shadowRoot ?? element).children)
  )
    .filter((ele) => ele instanceof HTMLElement)
    .some((ele) => isFocusable(ele) || isFocusableDeepWithin(ele));
};
